<template>
  <div class="contact_us">
    <div id="contact_us_image" class="index_intro_image">
      <img src="../../assets/contactus/request_top.jpg">
      <img src="../../assets/contactus/request_top_s.jpg">
    </div>
    <div id="intro_content">
      <h2>異業合作 洽詢專線&nbsp;&nbsp;02-2759-7167</h2>
      <p>上聯誠摯的希望與您共創和諧雙贏的未來，煩請填寫下列相關資料以便聯繫</p>
    </div>
    <div id="contact_table" class="container">
      <form id="contact_form">
        <inputNormal v-for="data in normal_inputs" :key="data.id" :data="data" v-model="data.value"></inputNormal>
        <div class="input_two" v-for="data in two_inputs" :key="data.id">
          <label :for="data.id" v-html="data.label"></label>
          <input class="sm" 
            :id="data.id"
            :type="data.type" 
            v-model="data.value_sm">
          <span> - </span>
          <input class="lg" 
            :id="data.id"
            :type="data.type" 
            v-model="data.value_lg">
        </div>
        <inputSelect v-for="data in select_inputs" :key="data.id" :data="data" v-model="data.value"></inputSelect>
        <div class="input_normal" :id="data.id" v-for="data in comment_box" :key="data.id">
          <label :for="data.id" v-html="data.label"></label>
          <textarea :type="data.type"
            :placeholder="data.placeholder" 
            v-model="data.value"></textarea>
        </div>
        <div id="contact_us_captcha" class="input_normal">
          <label for="cpatchaTextBox">驗證碼：</label>
          <input type="text" id="cpatchaTextBox" placeholder="請輸入驗證碼" v-model="captcha.input_code" />
          <div id="captcha"></div>
          <p class="hint">*驗證碼區分大小寫</p>
        </div>
        <div id="contact_btn_block">
          <div class="contact_button" @click="validateCaptcha">
            <div class="btm_box">確認送出</div>
          </div>
          <div class="contact_button" @click="reset">
            <div class="btm_box">清除重填</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import InputNormal from '@/components/ContactUs/InputNormal'
import InputSelect from '@/components/ContactUs/InputSelect'

export default {
  name: 'contactUs',
  data () {
    return {
      normal_inputs: [
        {id: 'company_name', label: '公司名稱：', type: 'text', value: '', placeholder: ''},
        {id: 'name', label: '姓　　名：', type: 'text', value: '', placeholder: ''},
        {id: 'job_title', label: '職　　稱：', type: 'text', value: '', placeholder: ''},
        {id: 'email', label: '電子郵件：', type: 'email', value: '', placeholder: ''},
        {id: 'phone', label: '行動電話：', type: 'text', value: '', placeholder: '填寫範例 0912345678'}
      ],
      two_inputs: [
        {id: 'tel', label: '聯絡電話：', type: 'text', value_sm: '', value_lg: ''},
        {id: 'fax', label: '傳　　真：', type: 'text', value_sm: '', value_lg: ''}
      ],
      select_inputs: [
        {
          id: 'cooperate_type', 
          label: '合作類型：', 
          options: [
            {name: '請選擇', value: '0'},
            {name: '協力廠商合作(印刷,模特兒,場地,飯店...等服務)', value: '1'},
            {name: '合作相關事項(異業合作...等事項)', value: '2'},
            {name: '合作辦展', value: '3'}
          ],
          value: '0'
        },
        {
          id: 'exhi_type', 
          label: '參展類別：', 
          options: [
            {name: '請選擇', value: '0'},
            {name: '連鎖加盟類', value: '1'},
            {name: '家居用品類', value: '2'},
            {name: '婦幼玩具類', value: '3'},
            {name: '旅遊休閒類', value: '4'},
            {name: '汽車類', value: '5'},
            {name: '茶類', value: '6'},
            {name: '素食/健康類', value: '7'},
            {name: '婚慶/珠寶類', value: '8'},
            {name: '3C資訊類', value: '9'},
            {name: '食品/伴手禮類', value: '10'},
            {name: '佛教/雕刻類', value: '11'}
          ],
          value: '0'
        }
      ],
      comment_box: [{id: 'comment_box', label: '結盟配合方式(不限字數)：', type: 'text', value: '', placeholder: ''}],
      captcha: {
        code: '',
        input_code: '',
        charsArray: '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
        lengthOtp: 6,
        captchaArr: []
      }
    }
  },
  components: {
    'inputNormal': InputNormal,
    'inputSelect': InputSelect
  },
  computed: {},
  methods: {
    submit() {
      alert('驗證成功，並已送出表單')
    },
    reset() {
      var app = this 
      app.createCaptcha()
      document.getElementById('contact_form').reset()
    },
    validateTable() {
      var app = this 
      var email = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/
      var cellphone = /^09[0-9]{8}$/
      var check_normal = app.normal_inputs.every((v) => {
        return v.value !== ''
      })
      var check_email = email.test(app.normal_inputs[3].value)
      var check_cellphone = cellphone.test(app.normal_inputs[4].value)
      var check_two = app.two_inputs.every((v) => {
        return v.value_sm !== '' && v.value_lg !== '' && [9, 10].indexOf((v.value_sm + v.value_lg).length) > -1
      })
      var check_select = app.select_inputs.every((v) => {
        return v.value !== '0'
      })
      if (check_normal && check_email && check_cellphone && check_two && check_select) {
        app.submit()
      } else {
        alert('請填妥表單後，再進行送出')
      }
    },
    createCaptcha() {
      var app = this
      var captcha = app.captcha
      document.getElementById('captcha').innerHTML = ""
      captcha.captchaArr = []
      for (var i = 0; i < captcha.lengthOtp; i++) {
        var index = Math.floor(Math.random() * captcha.charsArray.length + 1)
        if (captcha.captchaArr.indexOf(captcha.charsArray[index]) == -1)
          captcha.captchaArr.push(captcha.charsArray[index])
        else i--
      }
      var canv = document.createElement("canvas")
      canv.id = "captcha_image"
      canv.width = 120
      canv.height = 35
      var ctx = canv.getContext("2d")
      ctx.font = "23px Georgia"
      var gradient = ctx.createLinearGradient(0, 0, canv.width, 0)
      gradient.addColorStop("0", "magenta")
      gradient.addColorStop("0.5", "blue")
      gradient.addColorStop("1.0", "red")
      ctx.strokeStyle = gradient
      captcha.code = captcha.captchaArr.join("")
      ctx.strokeText(captcha.code, 0, 30)
      document.getElementById("captcha").appendChild(canv)
    },
    validateCaptcha() {
      var app = this
      if (app.captcha.input_code == app.captcha.code) {
        // app.submit()
        app.validateTable()
      } else {
        alert('驗證碼錯誤，請再試一次')
        app.createCaptcha()
      }
    }
  },
  mounted(){
    var app = this
    app.createCaptcha()
  }
}
</script>

<style lang="sass">
$pc-992-media: '992px'
$pad-768-media: '768px'
$mobile-576-media: '576px'

@mixin pc-width() 
  @media (max-width: $pc-992-media)
    @content

@mixin pad-width() 
  @media (max-width: $pad-768-media)
    @content

@mixin mobile-width() 
  @media (max-width: $mobile-576-media)
    @content

.contact_us 
  #contact_us_image
    margin-top: 25px
  #intro_content 
    background: #e2e2e2
    margin-top: 20px
    padding: 25px
    h2, p 
      margin: 0
      text-align: center
    h2 
      font-size: 35px
      margin-bottom: 15px
      @include mobile-width 
        font-size: 17px
    p 
      font-size: 21px
      @include mobile-width 
        font-size: 15px
  #contact_table 
    form 
      max-width: 460px
      margin: 30px auto
  #contact_btn_block
    display: flex 
    justify-content: space-around
    margin-top: 80px 
    .contact_button 
      display: flex
      justify-content: center
      align-items: center
      &:hover .btm_box
        background: #00a0e9
        color: white
      .btm_box 
        width: 150px
        text-align: center
        border: 2px solid #00a0e9
        height: 40px
        line-height: 36px
        color:#00a0e9
        font-weight: 700
        font-size: 21px
        cursor: pointer
        @include mobile-width 
          font-size: 17px

#contact_us_captcha 
  position: relative
  #cpatchaTextBox 
    @include mobile-width 
      font-size: 13px
  #captcha 
    display: inline-block
    position: absolute
    top: 10px
    margin-left: 20px
    background: #e6e6e6
    padding-left: 20px
    @include mobile-width 
      margin-left: 5px
  .hint 
    color: red 
    font-size: 15px


</style>
